import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from "react";

interface Theme {
  primaryColor: string;
  secondaryColor: string;
  leftSideBarColor: string;
  leftSideBarTextColor: string;
  topNavBgColor: string;
  topNavTextColor: string;
  mainColor: string;
  accentColor: string;
}

interface ThemeContextType {
  theme: Theme;
  setTheme: Dispatch<SetStateAction<Theme>>;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<Theme>({
    primaryColor: "",
    secondaryColor: "",
    leftSideBarColor: "#F6F5F5",
    leftSideBarTextColor: "#000",
    topNavBgColor: "#0D468A",
    topNavTextColor: "#F6F5F5",
    mainColor: "",
    accentColor: "",
  });

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within a ThemeProvider");
  }
  return context;
};
